// Save a Blob to the user's device under `filename`.
//
// Revoke later, not now: Safari aborts a download whose blob URL is revoked in
// the same task as the click (FileSaver.js waits too). Shared by the audit-log
// export and the "Download original" buttons.
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}
